import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  image_path: string = "../../../../assets/images/TablePreviewImages/";

  constructor() { }

  getImage(filename: string): string {
    return this.image_path + filename + ".png";
  }
}
